"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHVACSensorsByGroup = void 0;
const react_1 = require("react");
const types_1 = require("../../types");
const useSensors_1 = require("../useSensors");
const HVAC_SENSOR_TYPES = [
    types_1.SensorType.HVAC_CONDENSER_MONITOR,
    types_1.SensorType.HVAC_AIRHANDLER_MONITOR,
];
const useHVACSensorsByGroup = (selectedHubId) => {
    const { sensors, loading: sensorsLoading } = (0, useSensors_1.useSensors)(selectedHubId);
    const lastCalculationTime = (0, react_1.useRef)(0);
    const cachedResult = (0, react_1.useRef)([]);
    const THROTTLE_MS = 1000;
    const sensorKey = (0, react_1.useMemo)(() => {
        const now = Date.now();
        if (now - lastCalculationTime.current < THROTTLE_MS) {
            return 'throttled';
        }
        if (!selectedHubId || !sensors.length)
            return '';
        const hvacSensors = sensors.filter((sensor) => sensor.hubId === selectedHubId && HVAC_SENSOR_TYPES.includes(sensor.type));
        const key = hvacSensors
            .map((s) => `${s.id}-${s.groupId}-${s.name}`)
            .sort()
            .join('|');
        lastCalculationTime.current = now;
        return key;
    }, [sensors, selectedHubId]);
    const hvacSensorGroups = (0, react_1.useMemo)(() => {
        if (sensorKey === 'throttled') {
            return cachedResult.current;
        }
        if (!selectedHubId || !sensors.length)
            return [];
        const hvacSensors = sensors.filter((sensor) => sensor.hubId === selectedHubId && HVAC_SENSOR_TYPES.includes(sensor.type));
        const groupMap = new Map();
        hvacSensors.forEach((sensor) => {
            const groupId = sensor.groupId ?? 'default-sensor-group-id';
            if (!groupId)
                return;
            if (!groupMap.has(groupId)) {
                groupMap.set(groupId, { groupId });
            }
            const group = groupMap.get(groupId);
            let sensorConfig = sensor.sensorGroupConfiguration;
            if (typeof sensorConfig === 'string') {
                try {
                    sensorConfig = JSON.parse(sensorConfig);
                }
                catch (_error) {
                    sensorConfig = null;
                }
            }
            let isIndoor;
            if (sensorConfig?.indoor !== null && sensorConfig?.indoor !== undefined) {
                isIndoor = sensorConfig.indoor;
            }
            else if (sensor.type === types_1.SensorType.HVAC_AIRHANDLER_MONITOR) {
                isIndoor = true;
            }
            else if (sensor.type === types_1.SensorType.HVAC_CONDENSER_MONITOR) {
                isIndoor = false;
            }
            else {
                isIndoor = true;
            }
            if (isIndoor) {
                group.indoorSensor = sensor;
            }
            else {
                group.outdoorSensor = sensor;
            }
        });
        const result = Array.from(groupMap.values());
        cachedResult.current = result;
        return result;
    }, [sensorKey, selectedHubId]);
    return {
        hvacSensorGroups,
        loading: !!sensorsLoading,
        error: null,
    };
};
exports.useHVACSensorsByGroup = useHVACSensorsByGroup;
